var _rect, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.1543,
    y: 5.61536,
    width: 7.69231,
    height: 2.30769,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.99281 14.5179L1.58304 17.2201C1.1745 17.4419 0.664898 17.2938 0.436399 16.887C0.369666 16.759 0.334377 16.6169 0.333496 16.4724V10.424C0.333496 11.0237 0.671607 11.3938 1.56099 11.8084L6.99281 14.5179Z",
    fill: "#F9B42A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41288 0.666687H9.55805C11.8146 0.666687 13.6448 1.55506 13.6668 3.82783V16.4724C13.6659 16.6145 13.6306 16.7543 13.5639 16.8796C13.4568 17.0839 13.2718 17.2356 13.0514 17.2998C12.831 17.364 12.5942 17.3353 12.3952 17.2201L6.99281 14.518L1.56099 11.8084C0.671607 11.3938 0.333496 11.0237 0.333496 10.424V3.82783C0.333496 1.55506 2.16371 0.666687 4.41288 0.666687ZM3.85426 7.01858H10.124C10.4853 7.01858 10.7782 6.72359 10.7782 6.3597C10.7782 5.99581 10.4853 5.70082 10.124 5.70082H3.85426C3.49297 5.70082 3.20009 5.99581 3.20009 6.3597C3.20009 6.72359 3.49297 7.01858 3.85426 7.01858Z",
    fill: "#FFCC66"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1125_10000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41288 0.666687H9.55805C11.8146 0.666687 13.6448 1.55506 13.6668 3.82783V16.4724C13.6659 16.6145 13.6306 16.7543 13.5639 16.8796C13.4568 17.0839 13.2718 17.2356 13.0514 17.2998C12.831 17.364 12.5942 17.3353 12.3952 17.2201L6.99281 14.518L1.56099 11.8084C0.671607 11.3938 0.333496 11.0237 0.333496 10.424V3.82783C0.333496 1.55506 2.16371 0.666687 4.41288 0.666687ZM3.85426 7.01858H10.124C10.4853 7.01858 10.7782 6.72359 10.7782 6.3597C10.7782 5.99581 10.4853 5.70082 10.124 5.70082H3.85426C3.49297 5.70082 3.20009 5.99581 3.20009 6.3597C3.20009 6.72359 3.49297 7.01858 3.85426 7.01858Z",
    fill: "#FFA64D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1125_10000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: -2.53845,
    width: 8.46154,
    height: 21.5385,
    fill: "#FFA64D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.fcbb4475.svg";
export { ForwardRef as ReactComponent };